export type ConfigProps = {
    Sidebar_drawer: any;
    Customizer_drawer: boolean;
    mini_sidebar: boolean;
    setHorizontalLayout: boolean;
    setRTLLayout: boolean;
    actTheme: string;
    boxed: boolean;
    setBorderCard: boolean;
    darkMode: boolean;
    language: string;
};

const config: ConfigProps = {
    Sidebar_drawer: null,
    Customizer_drawer: false,
    mini_sidebar: false,
    setHorizontalLayout: false, // Horizontal layout
    setRTLLayout: false, // RTL layout
    actTheme: 'BLUE_THEME',
    // Padrão do Hub: exibição COMPLETA (full width) em todos os módulos
    // (decisão 2026-07-30). O usuário ainda pode ativar o boxed no customizer.
    boxed: false,
    setBorderCard: false,
    darkMode: false, // Modo escuro padrão
    language: 'pt-BR' // Idioma padrão
};

export default config;
